import PropTypes from 'prop-types';
import Platform from "react-native-web/dist/exports/Platform";
import getPropSelector from './getPropSelector';
const focusHandlerProps = {
  types: {
    /**
     * onBlur handler
     */
    onBlur: PropTypes.func,
    /**
     * onFocus handler
     */
    onFocus: PropTypes.func
  }
};
focusHandlerProps.select = getPropSelector(focusHandlerProps.types);
const textInputHandlerProps = {
  types: {
    /**
     * onChange handler
     */
    onChange: PropTypes.func,
    /**
     * onChangeText handler
     */
    onChangeText: PropTypes.func,
    /**
     * onClear handler
     */
    onClear: PropTypes.func,
    /**
     * onSubmit handler
     */
    onSubmit: PropTypes.func,
    /**
     * onSubmitEditing handler
     */
    onSubmitEditing: PropTypes.func,
    /**
     * onContentSizeChange handler
     */
    onContentSizeChange: PropTypes.func,
    /**
     * onEndEditing handler
     */
    onEndEditing: PropTypes.func,
    /**
     * onScroll handler
     */
    onScroll: PropTypes.func,
    /**
     * onSelectionChange handler
     */
    onSelectionChange: PropTypes.func,
    /**
     * onKeyPress handler
     */
    onKeyPress: PropTypes.func,
    /**
     * onKeyUp handler (only supported on Web)
     */
    onKeyUp: PropTypes.func,
    /**
     * onKeyDown handler (only supported on Web)
     */
    onMouseOver: PropTypes.func,
    /**
     * onKeyDown handler (only supported on Web)
     */
    onMouseOut: PropTypes.func
  }
};
const selectTextInputHandlers = getPropSelector(textInputHandlerProps.types);
textInputHandlerProps.select = props => {
  // Support for onKeyPress/onKeyUp/onKeyDown is inconsistent between React Native and React Native Web
  const {
    onKeyPress,
    onKeyUp,
    onKeyDown,
    ...resolvedProps
  } = selectTextInputHandlers(props);
  if (onKeyPress || onKeyUp || onKeyDown) {
    if (Platform.OS !== 'web') {
      // React Native only supports onKeyPress. Call any key handlers supplied in expected order.
      resolvedProps.onKeyPress = event => {
        if (typeof onKeyDown === 'function') onKeyDown(event);
        if (typeof onKeyPress === 'function') onKeyPress(event);
        if (typeof onKeyUp === 'function') onKeyUp(event);
      };
    } else {
      // React Native Web supports onKeyUp the normal way.
      if (onKeyUp) resolvedProps.onKeyUp = onKeyUp;
      // React Native Web doesn't support the `onKeyDown` prop name, but maps a supplied onKeyPress handler
      // to the onKeyDown event and calls it with a keydown event. Make React Native Web call either or both.
      if (onKeyPress || onKeyDown) {
        resolvedProps.onKeyPress = event => {
          if (typeof onKeyDown === 'function') onKeyDown(event);
          if (typeof onKeyPress === 'function') onKeyPress(event);
        };
      }
    }
  }
  return resolvedProps;
};
export { focusHandlerProps, textInputHandlerProps };